import MessageModalView from "../../app/angularjs/common/modal/message.html";
import ConfirmModalView from "../../app/angularjs/common/modal/confirm.html";
import HttpErrorModalView from "../../app/angularjs/common/modal/httpError.html";
import MailModalView from "../../app/angularjs/common/modal/mail.html";
import ImageModalView from "../../app/angularjs/common/modal/image.html";

angular.module("app")

.factory("modalService", ['$injector', function ($injector) {
    var instance = null;
    function remove() {
        instance = null;
    }
    var service = {
        message: function (options) {
            if (instance != null) return;
            var $uibModal = $injector.get("$uibModal");
            instance = $uibModal.open({
                animation: true,
                template: MessageModalView,
                controller: 'ModalInstanceCtrl',
                size: 'sm',
                resolve: {
                    options: function(){ return options; }
                }
            });
            instance.result.then(remove, remove)
        },
        confirm: function (options, size='sm') {
            if (instance != null) return;
            var $uibModal = $injector.get("$uibModal");
            instance = $uibModal.open({
                animation: true,
                template: ConfirmModalView,
                controller: 'ModalInstanceCtrl',
                size: size,
                resolve: {
                    options: function () { return options; }
                }
            });
            instance.result.then(remove, remove)
        },

        httpError: function (options) {
            if (instance != null) return;
            var $uibModal = $injector.get("$uibModal");
            instance = $uibModal.open({
                animation: true,
                template: HttpErrorModalView,
                controller: 'ModalInstanceCtrl',
                size: 'lg',
                resolve: {
                    options: function () { return options; }
                }
            });
            instance.result.then(remove, remove)
        },
        mail: function (options) {
            if (instance != null) return;
            var $uibModal = $injector.get("$uibModal");
            instance = $uibModal.open({
                animation: true,
                template: MailModalView,
                controller: 'ModalSendMailCtrl',
                size: 'lg',
                resolve: {
                    options: function () { return options; }
                }
            });
            instance.result.then(remove, remove)
        },
        image: function (options) {
            if (instance != null) return;
            var $uibModal = $injector.get("$uibModal");
            instance = $uibModal.open({
                animation: true,
                template: ImageModalView,
                controller: 'ModalAddImageCtrl',
                size: 'lg',
                resolve: {
                    options: function () { return options; }
                }
            });
            instance.result.then(remove, remove)
        },
    };
    return service;
}]);